import "components/jiffy/stars/stars";
import "components/jiffy/review-summary-scale-box/review-summary-scale-box";
import "components/jiffy/review-summary-vertical-scale-box/review-summary-vertical-scale-box";
import initPieCharts from "components/jiffy/review-pie-chart/review-pie-chart";
import "./review-summary.scss";

export default () => {
  initPieCharts();
};
